import {PAGETYPE} from '../constants'
import ReactGA from "react-ga4";

export const filterDataByPage = (result,styleId,lang,pageName)=>{
  let pageData = null;
  switch(pageName){
    case PAGETYPE.home_page:
      pageData = {
        data:result.pages?.homePage,
        theme:result.theme,
        url:result.url
      }
      break;
    case PAGETYPE.interview:
      pageData = {
        data:result.pages?.interview,
        theme:result.theme
      }
      break;  
    case PAGETYPE.warranty:
      pageData = {
        data:result.pages?.warrantyInfo,
        theme:result.theme
      }
      break;
      case PAGETYPE.care:
        pageData = {
          data:result.pages?.care,
          theme:result.theme
        }
        break;
        case PAGETYPE.repair:
          pageData = {
            data:result.pages?.repair,
            theme:result.theme
          }
          break;

          case PAGETYPE.resale:
            pageData = {
              theme:result.theme
            }
            break;

          case PAGETYPE.supply_chain:
            pageData = {
              theme:result.theme
            }
            break;

    case PAGETYPE.upcycle:
      pageData = {
        data:result.pages?.upcycle,
        theme:result.theme
      }
     // pageData = result?.styles[styleId][lang].pages?.upcycle
      break; 
    // case 'upcyle':
    //     pageData = result?.styles[styleId][lang].pages?.upcyle
    //   break;       
    default:
      pageData = result?.styles[styleId]      
  }
  return pageData;
}

export const dispatchAnalyticsEvent = 
(category,label,orgId,digitalId,
  styleId,style,lang
  ) => {
  ReactGA.event({
    category: category,
    action:label,
    orgId:orgId,
    digitalId:digitalId,
    styleId:styleId,
    style:style,
    lang:lang
  });
}

export const dispatchAnalyticsPageView = (path,title) =>{
  ReactGA.send({ hitType: "pageview", page: path, title: title });
}